import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M8.25 22A6.25 6.25 0 0 1 6.553 9.736a6.14 6.14 0 0 1 3.235-.04l6.59-6.588A3.75 3.75 0 0 1 19.049 2a2.95 2.95 0 0 1 2.947 2.947 3.76 3.76 0 0 1-1.107 2.672l-.56.56a1.68 1.68 0 0 1-1.178.488h-1.322V9.5a1.666 1.666 0 0 1-1.666 1.667h-.834v1.321a1.66 1.66 0 0 1-.488 1.179l-.542.541a6.1 6.1 0 0 1-.039 3.234 6.27 6.27 0 0 1-5.357 4.524A6 6 0 0 1 8.25 22m0-10.833a4.584 4.584 0 1 0 4.408 5.825 4.5 4.5 0 0 0-.084-2.75.83.83 0 0 1 .199-.863l.89-.89v-1.322A1.667 1.667 0 0 1 15.329 9.5h.834v-.833A1.667 1.667 0 0 1 17.829 7h1.322l.56-.56a2.1 2.1 0 0 0 .618-1.493 1.28 1.28 0 0 0-1.279-1.28 2.1 2.1 0 0 0-1.494.619l-6.943 6.942a.83.83 0 0 1-.863.197 4.6 4.6 0 0 0-1.504-.258zM6.163 17a.833.833 0 1 0 1.666 0 .833.833 0 0 0-1.666 0"
    }, null, -1)
  ]))]))
}
export default { render: render }